import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["select", "name", "hint"];

  showInput(event) {
    this.selectTarget.classList.toggle("d-none");
    this.nameTarget.classList.toggle("d-none");
    this.hintTarget.classList.toggle("d-none");
    event.target.innerText = "Annuler";
  }
}
